import { useAtomValue } from 'jotai';

import { AppHeader } from './sidebar/AppHeader';
import { navSections } from './sidebar/nav-data';
import { Sidebar } from './sidebar/Sidebar';
import { UserInfo } from './sidebar/UserInfo';
import { sidebarCollapseAtom } from '@/store/atoms';
import type { LayoutProps } from '@/types/sidebar';
import { NavItem, NavSection } from '@/types/sidebar';

export const Layout = ({ children }: LayoutProps) => {
  const isCollapsed = useAtomValue(sidebarCollapseAtom);

  return (
    <div className="bg-background h-full w-full overflow-hidden">
      <Sidebar className="fixed top-0 bottom-0 left-0 z-50">
        <AppHeader />

        {/* Navigation Sections */}
        <div className="flex-1 overflow-y-auto">
          {navSections.map((section: NavSection) => (
            <Sidebar.Section key={section.title} title={section.title}>
              {section.items.map((item: NavItem) => (
                <Sidebar.Link key={item.href} item={item} />
              ))}
            </Sidebar.Section>
          ))}

          {/* Standalone Items */}
          {/* <Sidebar.Section>
            {standaloneItems.map((item:) => (
              <Sidebar.Link key={item.href} item={item} />
            ))}
          </Sidebar.Section> */}
        </div>

        {/* Bottom Section with Toggle and User Info */}
        <div className="mt-auto">
          <UserInfo />
        </div>
      </Sidebar>

      <main
        className={`fixed right-0 h-screen overflow-hidden bg-slate-50 transition-all duration-300 ${
          isCollapsed ? 'left-[72px]' : 'left-64'
        }`}
      >
        {children}
      </main>
    </div>
  );
};
